/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import BaseIdObject from "@shared/BaseIdObject";
import {BookEntryTypeEnum} from "@shared/BookWriting/BookEntryTypeEnum";
import {BookLayoutPreferenceEnum} from "@shared/BookWriting/BookLayoutPreferenceEnum";

export default class BookEntryRef extends BaseIdObject {

	contentItemId: string = null
	entryType: BookEntryTypeEnum = BookEntryTypeEnum.CONTENT
	sortOrder: number = 0
	layoutPreference: BookLayoutPreferenceEnum = null
	sectionMetaTitle: string = null
	sourceSessionEntryId: string = null
	sourceSessionDateMs: number = null

	constructor(options = {}) {
		super(options);
		this.applyOptions(options);
	}

}
